import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "fto" } });

export const formatEventDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatEventTime = (iso) => {
  if (!iso) return "";
  const m = String(iso).match(/T(\d{2}):(\d{2})/);
  if (!m) return "";
  let h = parseInt(m[1], 10);
  const min = m[2];
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return min === "00" ? `${h}${ampm}` : `${h}:${min}${ampm}`;
};

// Split an event title like "FintechOmni Las Vegas 2027" into three lines: [brand, city, year]
// Falls back to a single line if the title doesn't match "... <city> <4-digit-year>".
export const splitEventTitle = (title) => {
  if (!title) return [""];
  const m = title.match(/^(.+?)\s+(.+?)\s+(\d{4})$/);
  if (m) return [m[1], m[2], m[3]];
  return [title];
};
